var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_SetMarginReminder"),
        width: "380px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            height: "80px",
            "align-items": "center",
            "padding-left": "20px"
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "inline-form",
              attrs: {
                inline: true,
                "label-width": "120px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_NumberOfCompanyReminders")
                  }
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "remindMargin",
                      min: 0,
                      max: 999,
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.remindMargin,
                      callback: function($$v) {
                        _vm.remindMargin = $$v
                      },
                      expression: "remindMargin"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.confirmSave }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }